module.exports = __webpack_public_path__ + "static/media/sample_division_health_bulk_upload.8ed1ff4a.csv";